import React, { useEffect, useRef } from 'react';
import { SHOW_CARD_PRIORITY } from '../../config';
import { toCardDate, isDueDateOverdue } from '../../utils/dateOnly';

export default function KanbanCard({
  card,
  isDragging,
  dragHandleProps,
  innerRef,
  draggableProps,
  style,
  onCardClick,
}) {
  const didDragRef = useRef(false);

  useEffect(() => {
    if (isDragging) {
      didDragRef.current = true;
    }
  }, [isDragging]);

  const assigneeLabel = card.assignedUserName || 'Unassigned';
  const priorityLabel = card.priorityName || 'No Priority';
  const dueDateOverdue = card.dueDate && isDueDateOverdue(card.dueDate);
  const isCallMeeting = Boolean(card.isCallMeeting ?? card.IsCallMeeting);

  const { onMouseDown: dragOnMouseDown, ...restDragHandleProps } = dragHandleProps || {};

  const handleMouseDown = (e) => {
    didDragRef.current = false;
    dragOnMouseDown?.(e);
  };

  const handleClick = () => {
    if (didDragRef.current || isDragging) {
      didDragRef.current = false;
      return;
    }
    onCardClick?.(card);
  };

  return (
    <div
      ref={innerRef}
      {...draggableProps}
      {...restDragHandleProps}
      style={style}
      className={`kanban-card-item${isDragging ? ' dragging' : ''}`}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      <div className="kanban-card-title" title={card.cardTitle}>
        {card.cardTitle}
      </div>

      <div className="kanban-card-meta-row mt-2">
        <div className="kanban-card-tags">
          <span className="kanban-tag kanban-tag-assignee" style={{ height: 'fit-content' }}>
            {assigneeLabel}
          </span>
          <span className="kanban-card-avatar" title={assigneeLabel}>
            <i className="fas fa-user" />
          </span>
        </div>
      </div>

      {(card.dueDate || SHOW_CARD_PRIORITY) && (
        <div className={`kanban-card-tags${SHOW_CARD_PRIORITY ? ' kanban-card-priority-row' : ''} mt-2`}>
          {card.dueDate && (
            <div className={`kanban-card-date-line${dueDateOverdue ? ' kanban-card-date-line-overdue' : ''}`}>
              <span className="kanban-card-date-label">Due Date:</span>
              <span className={`kanban-card-date${dueDateOverdue ? ' kanban-card-date-overdue' : ''}`}>
                {toCardDate(card.dueDate)}
              </span>
            </div>
          )}
          {SHOW_CARD_PRIORITY && (
            <span className="kanban-tag kanban-tag-priority">{priorityLabel}</span>
          )}
        </div>
      )}

      {isCallMeeting && (
        <div className="kanban-card-call-row">
          <span className="kanban-card-call-label" title="Call/Meeting">
            <i className="fas fa-phone" aria-hidden="true" />
            <span>Call/Meeting</span>
          </span>
        </div>
      )}
    </div>
  );
}
